// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"713":"c71cbe3c","775":"f49c3086","843":"78ad0fbf","904":"06f047e6"}[chunkId] + ".chunk.css";
};